export default __webpack_public_path__ + "static/media/029-lighthouse.2b5017ca.png";